/**
 * [pug template]
 */
<template lang="pug">
  input(type="text", :name="name", v-model="value")
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'input-text-component',
  props: {
    name: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      value: null
    }
  },
  created: function () {
    this.value = this.defaultValue
  },
  watch: {
    value: function (newValue, oldValue) {
      this.$emit('value-changed', newValue)
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// InputTextComponent.vue?605a515b